import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbCollapse, NgbDateParserFormatter, NgbDatepickerModule, NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { Subject } from 'rxjs';
import { ComboService } from '../../Model/Combo/combo.service';
import { SessionService } from '../../Util/Session/session.service';
import { CommonService } from '../../Model/Common/common.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { DailyAttendanceService } from '../../Model/WebAttendance/daily-attendance.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { RelieverComponent } from '../reliever/reliever.component';
import { MusterAttendanceService } from '../../Model/MusterAttendance/muster-attendance.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-daily-attendance',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, NgbNavModule, NgSelectModule, RouterModule, LoaderComponent, NgbDatepickerModule, NgbCollapse],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './daily-attendance.component.html',
  styleUrl: './daily-attendance.component.scss'
})
export class DailyAttendanceComponent {
  isDisabled: boolean = false;
  isGDisabled: boolean = false;
  allSelect: boolean = false;
  isCollapsed = false;
  TablesDatas: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  // dtTrigger2: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  // @ViewChild(DataTableDirective, { static: false }) dtElement2!: DataTableDirective;

  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  AllAttendance = [] as any;
  AttendanceTypes = [] as any;
  Shifts = [] as any;
  Duties = [] as any;
  Designations = [] as any;
  Relievers = [] as any;
  Reliever: any;
  DutyForEmployee = [] as any;
  DesignationDutyCombination = [] as any;
  showCombinations = false;

  Filter = {
    BranchId: null,
    ClientID: null,
    SiteID: null,
    SiteName: '',
    UserId: null,
    Date: null as any,
    DateObj: null as any,
    AttendanceType: null,
    ForDate: null,
    SelectAttendanceType: null,
    MarkAttendanceType: null,
    MarkShift: null,
    MarkDuty: null,
    InTime: "",
    OutTime: ""
  }

  CompanyPermiter = {
    IsAttendanceAfterDaysAllowed: false,
    AttendanceAfterDays: 0,
  }

  maxDate: any;
  dtoptions: DataTables.Settings = {};
  dtoptions2: DataTables.Settings = {};
  constructor(
    private combo: ComboService,
    private session: SessionService,
    protected common: CommonService,
    private toast: ToastService,
    private attendance: DailyAttendanceService,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private musterAttendance: MusterAttendanceService,
    private cdr: ChangeDetectorRef
  ) {
    const today = new Date();
    this.maxDate = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate()
    };
    this.dtoptions = { ...this.common.commonDToptions };
    // this.dtoptions2 = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
    this.ComboLoad('Attendance Type')
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
    // this.dtTrigger2.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    // this.dtTrigger2.unsubscribe();
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype === 'Branch') {
      this.Clients = [];
      this.Filter.BranchId = null;
      this.Sites = [];
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
    } else if (Combotype === 'Client') {
      console.log(this.Filter.BranchId);
      this.Filter.ClientID = null;
      this.Sites = [];
      this.Filter.SiteID = null;
    } else if (Combotype === 'Site') {
      this.Filter.SiteID = null;
    }

    this.combo.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client') ? this.Filter.BranchId : 0,
      'ClientId': (Combotype == 'Site') ? this.Filter.ClientID : 0,
      'SiteId': this.Filter.SiteID,
      'IsReport': false
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.Branchs = response.ComboLoad;
          this.clear();
        } else if (Combotype == 'Client') {
          if (this.Filter.BranchId == null) {
            this.Clients = [];
            this.Sites = [];
          } else {
            console.log(this.Filter.BranchId);
            this.Clients = response.ComboLoad;
          }
          this.clear();
        } else if (Combotype == 'Site') {
          if (this.Filter.ClientID == null) {
            this.Sites = [];
          } else {
            this.Sites = response.ComboLoad;
          }
          this.clear();
        } else if (Combotype == 'Attendance Type') {
          this.AttendanceTypes = response.ComboLoad;
        } else if (Combotype == 'AllShift') {
          this.Shifts = response.ComboLoad;
        } else if (Combotype == 'SiteDuty') {
          this.Duties = response.ComboLoad;
          this.DutyForEmployee = response.ComboLoad;
        } else if (Combotype == 'SiteDesignation') {
          this.Designations = response.ComboLoad;
        } else if (Combotype == 'SiteAllDesignationDuty') {
          this.DesignationDutyCombination = response.ComboLoad;
          if (this.Filter.SiteID != null) {
            this.showCombinations = true;
            this.Filter.SiteName = this.Sites.find((e: any) => e.SiteMasterID == this.Filter.SiteID).SiteName;
          } else {
            this.showCombinations = false;
            this.Filter.SiteName = '';
          }
          this.cdr.detectChanges();

          setTimeout(() => {
            this.initializeComboTable('#comboTable', this.DesignationDutyCombination);
          }, 0);

        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  LoadAttendance() {
    this.TablesDatas = [];

    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.clear();
        dtInstance.draw();
        dtInstance.destroy();
        this.allSelect = false;

        setTimeout(() => {
          this.dtTrigger.next(null);
        }, 1);
      });
    } else {
      this.dtTrigger.next(null);
    }

    if (this.Filter.Date === null || this.Filter.Date === '') {
      this.toast.show({ message: "Please select Date", type: toastTypeEnum.warning });
    }
    else if (this.Filter.BranchId === null || this.Filter.BranchId === '') {
      this.toast.show({ message: "Please select Branch", type: toastTypeEnum.warning });
    }
    else if (this.Filter.ClientID === null || this.Filter.ClientID === '') {
      this.toast.show({ message: "Please select Client", type: toastTypeEnum.warning });
    }
    else if (this.Filter.SiteID === null || this.Filter.SiteID === '') {
      this.toast.show({ message: "Please select Site", type: toastTypeEnum.warning });
    } else {
      try {
        this.isDisabled = true;
        this.isGDisabled = true;
        this.ComboLoad('SiteDuty');
        this.ComboLoad('AllShift');
        this.ComboLoad('SiteDesignation');
        // this.ComboLoad('SiteAllDesignationDuty');
        this.attendance.Attendance_MaxConnect({
          SelectType: 'DA',
          AttendanceDate: this.dateFormat.format(this.Filter.Date),
          SiteID: this.Filter.SiteID,
        }).subscribe({
          next: (response) => {
            if (response.Table) {
              if (response.Table[0].MessageType === "ERROR") {
                this.toast.show({ message: response.Table[0].Message, type: toastTypeEnum.warning });
                this.isDisabled = false;
                this.isGDisabled = false;
                return;
              } else if (response.Table1.length == 0) {
                this.toast.show({ message: 'No Data Available', type: toastTypeEnum.warning });
                this.isDisabled = false;
                this.isGDisabled = false;
                return;
              }
              else {
                this.TablesDatas = Object.values([...response.Table1]);
                this.TablesDatas.forEach((e: any) => {
                  if (!(this.Designations.find((f: any) => f.DesignationMasterID == e.DesignationMasterID))) {
                    e.DesignationMasterID = null;
                  }
                  if (!(this.Duties.find((f: any) => f.DutyMasterID == e.DutyMasterID))) {
                    e.DutyMasterID = null;
                  }
                  if (!(this.Shifts.find((f: any) => f.ShiftMasterID == e.ShiftMasterID))) {
                    e.ShiftMasterID = null;
                  }
                })
                for (let data of this.TablesDatas) {
                  // if (data.DailyAttendanceInOutID == 0) {
                  //   data.selected = true;
                  // }
                  if (data.InTime === null) {
                    data.InTime = "00:00"
                  } else {
                    data.InTime = data.InTime.split(" ")[1].split(":")[0] + ":" + data.InTime.split(" ")[1].split(":")[1];
                  }

                  if (data.OutTime === null) {
                    data.OutTime = "00:00"
                  } else {
                    data.OutTime = data.OutTime.split(" ")[1].split(":")[0] + ":" + data.OutTime.split(" ")[1].split(":")[1];
                  }
                  data.InDate = this.Filter.Date;
                  data.OutDate = this.dateFormat.format(this.Filter.Date);
                }
                if (this.dtElement) {
                  this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                    dtInstance.destroy();
                    this.dtTrigger.next(null);
                  });
                }
                this.isDisabled = false;
                this.isGDisabled = false;
              }
            }
            else {
              this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
              this.isDisabled = false;
              this.isGDisabled = false;
            }

          }
        })
      } catch (error) {
        this.isDisabled = false;
        this.isGDisabled = false;
        console.error('Error occurred:', error);
      }
    }
  }

  selectAll(event: any) {
    const isChecked = event.target.checked;
    for (let data of this.TablesDatas) {
      data.selected = isChecked;
    }
  }

  resetSelection() {
    for (let data of this.TablesDatas) {
      if (data.selected === false) {
        this.allSelect = false;
        return;
      }
    }
  }

  selectRow(event: any, shift: any) {
    shift.selected = event.target.checked;
  }

  async Save() {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (result) {
        this.InsertUpdate();
      }
    }).catch(() => { });
  }

  // InsertUpdate() {
  //   const SelectedData = this.TablesDatas.filter(data => data.selected === true);

  //   if (this.TablesDatas.length !== 0 && SelectedData.length === 0) {
  //     this.toast.show({ message: 'Select any data to continue', type: toastTypeEnum.warning });
  //     return
  //   }

  //   if (SelectedData.length === 0) {
  //     this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
  //     return;
  //   }

  //   for (let i = 0; i < SelectedData.length; i++) {
  //     for (let j = i + 1; j < SelectedData.length; j++) {
  //       if ((SelectedData[i].EmpCode === SelectedData[j].EmpCode) && (SelectedData[i].DesignationMasterID === SelectedData[j].DesignationMasterID) && (SelectedData[i].DutyMasterID === SelectedData[j].DutyMasterID) && (SelectedData[i].ShiftMasterID === SelectedData[j].ShiftMasterID)) {
  //         this.toast.show({ message: `Duplicate record found for ${SelectedData[i].FullName}. Please ensure each employee has a unique Designation, Duty and Shift`, type: toastTypeEnum.danger });
  //         return;
  //       }
  //     }
  //   }

  //   const AttendanceDetail = SelectedData.map(data => {
  //     return {
  //       DailyAttendanceInOutId: data.DailyAttendanceInOutID,
  //       EmpMasterId: data.EmpMasterID,
  //       BranchId: data.BranchMasterID,
  //       SiteId: data.SiteMasterId,
  //       DesignationId: data.DesignationMasterID,
  //       DutyId: data.DutyMasterID,
  //       ShiftMasterId: data.ShiftMasterID,
  //       AttendanceRemark: data.AttendanceRemark
  //     }
  //   })

  //   const AttendanceDataUpdate = {
  //     SelectType: "I",
  //     AttendanceDate: this.dateFormat.format(this.Filter.Date),
  //     MaxConnectToSelfAttendance: AttendanceDetail
  //   }

  //   for (let i = 0; i < SelectedData.length; i++) {
  //     if (SelectedData[i].DesignationMasterID == null || SelectedData[i].DutyMasterID == null || SelectedData[i].ShiftMasterID == null) {
  //       this.toast.show({ message: `Select All Fields for  ${SelectedData[i].FullName}`, type: toastTypeEnum.warning });
  //       return;
  //     }
  //   }
  //   this.isDisabled = true;
  //   this.attendance.Attendance_Save(AttendanceDataUpdate).subscribe(
  //     data => {
  //       if (data.ESS_SaveAttendance_MaxConnect[0].MessageType == "SUCCESS") {
  //         this.toast.show({ message: "Data Uploaded Successfully", type: toastTypeEnum.success });
  //         this.isDisabled = false;
  //         this.TablesDatas = [];
  //         if (this.dtElement.dtInstance) {
  //           this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //             dtInstance.destroy();
  //             this.dtTrigger.next(null);
  //           });
  //         }
  //         this.Filter.Date = null;
  //         this.Filter.BranchId = null;
  //         this.Filter.ClientID = null;
  //         this.Filter.SiteID = null;
  //       }
  //       else {
  //         this.toast.show({ message: data.ESS_SaveAttendance_MaxConnect[0].Message, type: toastTypeEnum.warning });
  //         this.isDisabled = false;
  //       }
  //     },
  //     error => {
  //       console.error('Error:', error);
  //       this.isDisabled = false;
  //     });
  // }

  InsertUpdate() {
    const SelectedData = this.TablesDatas.filter(data => data.selected === true);

    if (this.TablesDatas.length !== 0 && SelectedData.length === 0) {
      this.toast.show({ message: 'Select any data to continue', type: toastTypeEnum.warning });
      return
    }

    if (SelectedData.length === 0) {
      this.toast.show({ message: 'No Data Available!', type: toastTypeEnum.warning });
      return;
    }

    for (let i = 0; i < SelectedData.length; i++) {
      for (let j = i + 1; j < SelectedData.length; j++) {
        if ((SelectedData[i].EmpCode === SelectedData[j].EmpCode) && (SelectedData[i].DesignationMasterID === SelectedData[j].DesignationMasterID) && (SelectedData[i].DutyMasterID === SelectedData[j].DutyMasterID) && (SelectedData[i].ShiftMasterID === SelectedData[j].ShiftMasterID)) {
          this.toast.show({ message: `Duplicate record found for ${SelectedData[i].EmpCode} - ${SelectedData[i].FullName}. Please ensure each employee has a unique Designation, Duty and Shift`, type: toastTypeEnum.danger });
          return;
        }
      }
    }

    for (let i = 0; i < SelectedData.length; i++) {
      if (!(this.DesignationDutyCombination.filter((e: any) => (e.DesignationMasterID == SelectedData[i].DesignationMasterID && e.DutyMasterID == SelectedData[i].DutyMasterID)).length > 0)) {
        this.toast.show({ message: `Designation Duty combination doesn't exist for ${SelectedData[i].EmpCode} - ${SelectedData[i].FullName}.`, type: toastTypeEnum.danger });
        return;
      }
    }

    const AttendanceDetail = SelectedData.map(data => {
      return {
        DailyAttendanceInOutId: data.DailyAttendanceInOutID,
        EmpMasterId: data.EmpMasterID,
        BranchId: data.BranchMasterID,
        SiteId: data.SiteMasterId,
        DesignationId: data.DesignationMasterID,
        DutyId: data.DutyMasterID,
        ShiftMasterId: data.ShiftMasterID,
        AttendanceRemark: data.AttendanceRemark,
        BillableOT: Math.floor(parseFloat(data.BillableOT) * 100) / 100,
        NonBillableOT: Math.floor(parseFloat(data.NonBillableOT) * 100) / 100,
      }
    })

    const AttendanceDataUpdate = {
      SelectType: "I",
      AttendanceDate: this.dateFormat.format(this.Filter.Date),
      MaxConnectToSelfAttendance: AttendanceDetail
    }

    for (let i = 0; i < SelectedData.length; i++) {
      if (SelectedData[i].DesignationMasterID == null || SelectedData[i].DutyMasterID == null || SelectedData[i].ShiftMasterID == null || SelectedData[i].AttendanceRemark == null) {
        this.toast.show({ message: `Select All Fields for EmpCode  ${SelectedData[i].EmpCode} - ${SelectedData[i].FullName}`, type: toastTypeEnum.warning });
        return;
      }
    }

    for (let i = 0; i < SelectedData.length; i++) {
      if (SelectedData[i].BillableOT < 0 || SelectedData[i].BillableOT > 24) {
        this.toast.show({ message: `OT should be in between 0 to 24 for employee code ${SelectedData[i].EmpCode}`, type: toastTypeEnum.warning });
        return;
      }
    }

    for (let i = 0; i < SelectedData.length; i++) {
      if (SelectedData[i].NonBillableOT < 0 || SelectedData[i].NonBillableOT > 24) {
        this.toast.show({ message: `OT should be in between 0 to 24 for employee code  ${SelectedData[i].EmpCode}`, type: toastTypeEnum.warning });
        return;
      }
    }

    this.isDisabled = true;
    this.attendance.Attendance_Save(AttendanceDataUpdate).subscribe(data => {
      if (data.ESS_SaveAttendance_MaxConnect[0].MessageType == "SUCCESS") {
        this.toast.show({ message: "Data Uploaded Successfully", type: toastTypeEnum.success });
        this.isDisabled = false;
        this.TablesDatas = [];
        if (this.dtElement.dtInstance) {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.Filter.Date = null;
        this.Filter.BranchId = null;
        this.Filter.ClientID = null;
        this.Filter.SiteID = null;
      }
      else {
        this.toast.show({ message: data.ESS_SaveAttendance_MaxConnect[0].Message, type: toastTypeEnum.warning });
        this.isDisabled = false;
      }
    },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }

  formatInOutTime(s: any) {
    if (s === null) {
      return "";
    }

    if (s !== "") {
      let intime = s;
      let date = new Date(intime);

      let formattedDate = date.toLocaleString("en-GB", {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      console.log(true);
      return formattedDate;
    }
    return "";
  }

  selectAttendanceType(AttendanceType: null) {
    console.log(AttendanceType);
    for (let data of this.TablesDatas) {
      if (data.AttendanceRemark === AttendanceType) {
        data.selected = true;
      } else {
        data.selected = false;
      }
    }
  }

  loadDuty(DesignationMasterID: number, rowIndex: number) {
    this.combo.ComboLoad({
      'Combotype': "Duty",
      'designationid': DesignationMasterID
    }).subscribe({
      next: (response) => {
        this.Duties = response.ComboLoad;
      }
    })
    this.TablesDatas[rowIndex].DutyMasterID = null;
  }

  markAttendanceType(AttendanceType: any) {
    // for (let data of this.TablesDatas) {
    //   data.AttendanceRemark = AttendanceType;
    //   data.selected = true;
    // }

    for (let data of this.TablesDatas) {
      if (data.selected) {
        data.AttendanceRemark = AttendanceType;
      }
    }
  }

  markDuty(Duty: any) {
    for (let data of this.TablesDatas) {
      if (data.selected) {
        if (data.DutyMasterID == null || data.DutyMasterID == '') {
          for (let duty of this.Duties) {
            if (duty.DutyMasterID == Duty) {
              data.DutyMasterID = Duty;
              data.selected = true;
            }
          }
        }
      }
    }
  }

  loadDutyforEmployee(DesignationMasterID: number, rowIndex: number) {
    this.combo.ComboLoad({
      'Combotype': "Duty",
      'designationid': DesignationMasterID
    }).subscribe({
      next: (response) => {
        this.DutyForEmployee = response.ComboLoad;
      }
    })
  }

  markShift(Shift: any) {
    for (let data of this.TablesDatas) {
      if (data.selected) {
        if (data.ShiftMasterID == null) {
          data.ShiftMasterID = Shift;
        }
      }
    }
  }

  clearAttendanceMark() {
    for (let data of this.TablesDatas) {
      data.selected = false;
    }
  }

  AddReliever() {
    if (!this.Filter.SiteID) {
      this.toast.show({ message: "Please select mandatory details", type: toastTypeEnum.warning });
      return;
    }
    const modalRef = this.modalService.open(RelieverComponent, {
      centered: true,
      backdrop: 'static',
      size: 'lg'
    })
    const data = {
      SiteId: this.Filter.SiteID,
      Date: this.dateFormat.format(this.Filter.Date)
    }
    modalRef.componentInstance.dData = data;
    modalRef.result.then((result) => {
      console.log('Modal closed with result:', result);
      this.Reliever = result;
      this.RelieverUpdate();
    },
      (reason) => {
        console.log('Modal dismissed with reason:', reason);
      }
    );
  }

  RelieverUpdate() {
    if (this.Reliever) {
      this.Reliever.selected = true;
      this.TablesDatas.push(this.Reliever);
      if (this.dtElement.dtInstance) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      }
      console.log(this.TablesDatas);
    }
  }

  clearField(type: string) {
    if (type === 'Branch') {
      this.Clients = [];
      this.Sites = [];
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      console.log('Clients', this.Clients);
      console.log('Sites', this.Sites);
    } else if (type === 'Client') {
      this.Sites = [];
      this.Filter.SiteID = null;
    }
  }

  selectLocation(type: string) {
    if (type === 'Client') {
      if (this.Filter.BranchId === null || this.Filter.BranchId === '') {
        this.toast.show({ message: "Please select Branch", type: toastTypeEnum.warning });
      }
    } else if (type === 'Site') {
      if (this.Filter.ClientID === null || this.Filter.ClientID === '') {
        this.toast.show({ message: "Please select Client", type: toastTypeEnum.warning });
      }
    }
  }

  shiftChange(index: number, shiftMasterID: number) {
    const selected = this.Shifts.find((site: { ShiftMasterID: number; }) => site.ShiftMasterID == shiftMasterID);
    this.TablesDatas[index].InTime = selected ? selected.InTime : "00:00";
    this.TablesDatas[index].OutTime = selected ? selected.OutTime : "00:00";
    if (selected.RotationalShift) {
      // Convert the OutDate to a JavaScript Date object
      let outDateObj = new Date(
        this.Filter.Date.year,
        this.Filter.Date.month - 1, // Adjust for 0-indexed month
        this.Filter.Date.day
      );
      outDateObj.setDate(outDateObj.getDate() + 1);

      this.TablesDatas[index].OutDate = {
        year: outDateObj.getFullYear(),
        month: outDateObj.getMonth() + 1,
        day: outDateObj.getDate()
      };

      this.TablesDatas[index].OutDate = this.dateFormat.format(this.TablesDatas[index].OutDate);
    } else {
      this.TablesDatas[index].OutDate = this.dateFormat.format(this.Filter.Date);
    }

  }
  datechange() {
    this.Filter.DateObj = this.dateFormat.format(this.Filter.Date);
  }

  validateInput(event: any) {
    let value = event.target.value;

    // Remove invalid characters (keep digits and dot only)
    value = value.replace(/[^0-9.]/g, '');

    // Only allow one dot
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts[1];
    }

    // Limit to two digits after decimal
    if (parts[1]) {
      parts[1] = parts[1].slice(0, 2);
      value = parts[0] + '.' + parts[1];
    }

    event.target.value = value;
  }

  clear() {
    // Clear the data array
    this.TablesDatas = [];

    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.clear();
        dtInstance.draw();
        dtInstance.destroy();
        this.allSelect = false;

        setTimeout(() => {
          this.dtTrigger.next(null);
        }, 1);
      });
    } else {
      this.dtTrigger.next(null);
    }
  }

  ESS_GetCompanyParameterOAS(): Promise<any> {
    this.ComboLoad('SiteAllDesignationDuty');
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.musterAttendance.ESS_GetCompanyParameterOAS({ SelecType: 'cp', SiteId: this.Filter.SiteID }).subscribe({
        next: (response) => {
          this.Filter.Date = null;
          const today = new Date();
          if (response.Table && response.Table.length > 0) {
            this.CompanyPermiter.IsAttendanceAfterDaysAllowed = response.Table[0].IsAttendanceAfterDaysAllowed;
            this.CompanyPermiter.AttendanceAfterDays = response.Table[0].AttendanceAfterDays;
            if (this.CompanyPermiter.IsAttendanceAfterDaysAllowed) {
              let maxAllowedDate = new Date(today);

              if (this.CompanyPermiter.IsAttendanceAfterDaysAllowed) {
                maxAllowedDate.setDate(today.getDate() + this.CompanyPermiter.AttendanceAfterDays);
              }

              this.maxDate = {
                year: maxAllowedDate.getFullYear(),
                month: maxAllowedDate.getMonth() + 1,
                day: maxAllowedDate.getDate()
              };
            } else {
              this.maxDate = {
                year: today.getFullYear(),
                month: today.getMonth() + 1,
                day: today.getDate()
              };
            }
          } else {
            this.maxDate = {
              year: today.getFullYear(),
              month: today.getMonth() + 1,
              day: today.getDate()
            };
          }
          this.isDisabled = false;
          resolve(true);
        },
        error: (err) => {
          this.isDisabled = false;
          reject(err);
        }
      });
    });
  }

  initializeComboTable(selector: string, data: any[]) {

    const tableElement = $(selector);

    if (tableElement.length === 0) {
      console.error(`Table ${selector} not found`);
      return;
    }

    // ✅ Proper destroy (ONLY ONCE)
    if ($.fn.dataTable.isDataTable(selector)) {
      $(selector).DataTable().clear().destroy();
      $(selector).empty();
      $(selector).off();
    }

    // ✅ define columns
    const columns = [
      {
        title: '#',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          return `<strong>${meta.row + 1}</strong>`;
        }
      },
      {
        title: 'Designation',
        data: 'DesignationName'
      },
      {
        title: 'Duty',
        data: 'DutyName'
      }
    ];

    // ✅ initialize ONLY ONCE
    $(selector).DataTable({
      data: data,
      columns: columns,
      paging: true,
      searching: true,
      ordering: true,
      autoWidth: false
    });
  }
}